import { REPORT_DATE } from "../constants/mainAPI";
import { ErrorResponseType, PageSearch } from "../types/api/main";
import { ReportDateSearch, ReportControlPointSuccessResponse } from "../types/api/report";
import { toFormData } from "../utils/toFormData";
import { doDeleteRequest, doGetRequest, doPostRequest } from "./mainAPI";

export const getReportControlPoints = (
    callback?: (resp: ReportControlPointSuccessResponse) => any,
    errorCallback?: (resp: any) => void,
    searchParams?: ReportDateSearch & PageSearch,
) => {
    return doGetRequest(`${REPORT_DATE}`, true, searchParams, callback, errorCallback);
};

export const getReportControlPoint = (
    id: number | undefined,
    callback?: (resp: any) => any,
    errorCallback?: (resp: any) => void,
) => {
    return doGetRequest(`${REPORT_DATE}/${Number(id)}`, true, {}, callback, errorCallback);
};

export const createNewReportControlPoint = (
    data: any,
    callback?: (resp: any) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    const formData = toFormData(data);

    return doPostRequest(REPORT_DATE, true, formData, {}, callback, errorCallback);
};

export const deleteReportControlPoint = (
    id: number | undefined,
    callback?: (resp: any) => void,
    errorCallback?: (resp: any) => void,
) => {
    return doDeleteRequest(`${REPORT_DATE}/${Number(id)}`, true, {}, callback, errorCallback);
};
